export default {
    namespaced: true,
    state: {
        caseId: "",
        // 订单编号
        caseNo: "",
        //案件信息默认页面
        caseInfoActiveName: "essential-information",
        //通讯录默认页面
        addListActiveName: "telephone-book",
        //历史信息默认页面
        historyInfoActiveName: "telephone-action-history",
        // 是否添加了催记
        addRecordFlag: false,
        // 新加
        hiddenCaseList: false,
        hiddenAction: false,
        hiddenCollectionStatus: false,
        otherData: {},
        // 哪个菜单进入
        menuChannel: -1
    },
    mutations: {
        updateCaseId: function (state, data) {
            state.caseId = data;
        },
        updateCaseNo: function (state, data) {
            state.caseNo = data;
        },
        resetActiveName: function (state) {
            state.caseInfoActiveName = "essential-information";
            state.addListActiveName = "telephone-book";
            state.historyInfoActiveName = "telephone-action-history";
        },
        updateAddListActiveName: function (state, data) {
            state.addListActiveName = data;
        },
        updateHistoryInfoActive: function (state, data) {
            state.historyInfoActiveName = data;
        },
        updateCaseInfoActiveName: function (state, data) {
            state.caseInfoActiveName = data;
        },
        updateAddRecordFlag: function (state, flag) {
            state.addRecordFlag = flag;
        },
        updateCollectionSign: function (state, data) {
            state.collectionSign = data;
        },
        //
        updateHiddenCaseList: function (state, data) {
            state.hiddenCaseList = data;
        },
        updateMenuChannel: function (state, menuChannel) {
            state.menuChannel = menuChannel;
        },
        updateHiddenAction: function (state, hidden) {
            state.hiddenAction = hidden;
        },
        updateHiddenCollectionStatus: function (state, hidden) {
            state.hiddenCollectionStatus = hidden;
        },
        updateOtherData: function (state, value) {
            state.otherData = value;
        }
    },
    getters: {},
    actions: {
        setCollectionData: function (_a, _b) {
            var commit = _a.commit;
            var caseId = _b.caseId, detailOptions = _b.detailOptions;
            //设置caseId
            commit("updateCaseId", caseId);
            //重置活动区域
            commit("resetActiveName");
            commit("updateCaseNo", "");
            commit("updateHiddenCaseList", detailOptions.hiddenCaseList === true);
            commit("updateHiddenAction", detailOptions.hiddenAction === true);
            commit("updateHiddenCollectionStatus", detailOptions.hiddenCollectionStatus === true);
            commit("updateOtherData", detailOptions.otherData || {});
            commit("updateMenuChannel", detailOptions.menuChannel);
        }
    }
};
